// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":0,"remove":true}!./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7be5b067","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader!./node_modules/stylus-loader!./src/stylus/components/_overlay.styl
// module id = 66
// module chunks = 0